<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xii"></a><a id="page_xiii"></a><span class="small">THE</span> CALLS <span class="small">OF</span> ISLAM</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle01.vue?fc57d194